import noData from "../assets/animations/TableLoader.json";
import { Box, Typography } from "@mui/material";
import Lottie from "lottie-react";

export const OverAllLoader = ({ message = "Loading...." }) => {
  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        backdropFilter: "blur(5px)",
        backgroundColor: "rgba(255, 255, 255, 0.6)",
        zIndex: 9999,
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Lottie
          animationData={noData}
          loop={true}
          size={100}
          style={{ height: "", width: "200px" }}
        />
       <Typography sx={{color:"black",fontSize:"16px",fontWeight:700}}>{message}</Typography>
      </Box>
    </Box>
  );
};
